(function() {
  angular.module("irricrops")
    .factory('newCacheManager', function () {

      var AbsoluteData = {};

      var consoleLog = function(string){
        //console.log(string);
      };


    // nombre de accion, usara nombres similares a los estados
      var Actions = {
        'equipo':{ //testing
          clean:[//array de datos que se limpiaran
            'cuartel.estadisticas', //nombres de los datos
            'equipo.alertas'
          ]
        },
        'add.vinedo.et':{
          clean: [
            'vinedo.evapotranspiracion',
            'cuartel.data',
            'cuartel.estadisticas',
          ]
        },
        'upload.vinedo.all':{
          clean: [
            'vinedo.evapotranspiracion',
            'vinedo.precipitacion',
            'vinedo.temperatura',
            'cuartel.data',
            'cuartel.estadisticas',
          ]
        },
        'upload.vinedo.evapotranspiracion':{
          clean: [
            'vinedo.evapotranspiracion',
            'cuartel.data',
            'cuartel.estadisticas',
          ]
        },
        'upload.vinedo.precipitaciones':{
          clean: [
            'vinedo.precipitacion',
            'cuartel.data',
            'cuartel.estadisticas',
          ]
        },
        'upload.vinedo.temperaturas':{
          clean: [
            'vinedo.temperatura',
            'cuartel.data',
            'cuartel.estadisticas',
          ]
        },







        'add.equipo.resumen.riego':{
          clean: [
            'equipo.resumen',
            'equipo.riegos',
          ]
        },
        'add.equipo.scholander':{
          clean: [
            'equipo.alertas',
            'equipo.resumen',
            'cuartel.data',
            'cuartel.estadisticas',
          ]
        },
        'add.equipo.programacion':{
          clean: [
            'equipo.alertas',
            'equipo.riegos',
            'cuartel.data',
            'cuartel.estadisticas',
          ]
        },
        //igual que programacion
        'add.equipo.real':{
          clean: [
            'equipo.alertas',
            'equipo.riegos',
            'cuartel.data',
            'cuartel.estadisticas',
          ]
        },







      };

      var splitName = function splitName(nameData) {
        if (typeof nameData == 'string' ) {
          nameDataArray = nameData.split('.');
        }else{
          consoleLog("no string data: "+nameData);
          return false;
        }
        return nameDataArray;
      };

    var existData = function existData(nameData, id, unixDate) {
      consoleLog("existData: "+nameData + " "+ id + " " + unixDate);

      unixDate = unixDate || actualUnix;
      unixDate = roundUnix(unixDate);

      exist = false;
      nameDataArray = splitName(nameData);

      if (angular.isDefined(nameDataArray[1])){
        //get child
        if (angular.isDefined(AbsoluteData[nameDataArray[0]]) &&
            angular.isDefined(AbsoluteData[nameDataArray[0]][id]) &&
            angular.isDefined(AbsoluteData[nameDataArray[0]][id][unixDate]) &&
            angular.isDefined(AbsoluteData[nameDataArray[0]][id][unixDate][nameDataArray[1]])
          ) {
          //existe padre e hijo en AbsoluteData
          //console.dir( AbsoluteData[nameDataArray[0]][id][unixDate][nameDataArray[1]]);
          exist = true;
        }else{
          consoleLog("child undefined ("+ nameData +" unix: "+ unixDate +"  id = "+id+")");
        }
      }else{
        if (angular.isDefined(AbsoluteData[nameDataArray[0]]) &&
            angular.isDefined(AbsoluteData[nameDataArray[0]][id]) &&
            angular.isDefined(AbsoluteData[nameDataArray[0]][id][unixDate])) {
          //existe padre en AbsoluteData
          exist = true;
        }else{
          consoleLog("parent undefined ("+ nameData +" unixDate:"+ unixDate +"  id = "+id+")");
        }
      }

      consoleLog("exist? : "+exist);
      return exist;
    };

    var roundUnix = function(unixDate){
      var newUnix = moment.unix(unixDate).hours(0).minutes(0).seconds(0).milliseconds(0).unix();
      return newUnix;
    };

    var actualUnix = moment(new Date()).hours(0).minutes(0).seconds(0).milliseconds(0).unix();

    /*
    * get data con el nombre e id
    * nombres como 'vinedo', 'vinedo.et','equipo', 'equipo.alertas', 'equipo.scholander'
    * con la id del elemento correspondiente
    * */


      //'equipo'
      //'equipo.alertas'
      var get  = function get (nameData, id, unixDate) {
        consoleLog("GET nameData:"+nameData+" id:"+id+" unixDate:"+unixDate);

        unixDate = unixDate || actualUnix;
        unixDate = roundUnix(unixDate);

        if (existData(nameData, id, unixDate)) {
          nameDataArray = splitName(nameData);
          if (angular.isDefined(nameDataArray[1])) {
            return AbsoluteData[nameDataArray[0]][id][unixDate][nameDataArray[1]] ;
          }else{
            return AbsoluteData[nameDataArray[0]][id][unixDate] ;
          }
        }
        consoleLog("data no found ("+ nameData +" unix: "+ unixDate +"  id = "+id+")");
        return undefined;
      };


      var set  = function get (nameData, id, data, unixDate) {
        consoleLog("SET: "+nameData + " "+ id + " " + unixDate);
        console.dir(data);
        unixDate = unixDate || actualUnix;
        unixDate = roundUnix(unixDate);

        nameDataArray = splitName(nameData);

        //define variables
          if (angular.isUndefined(AbsoluteData[nameDataArray[0]])) {
            AbsoluteData[nameDataArray[0]] = {};
            AbsoluteData[nameDataArray[0]][id] = {};
            AbsoluteData[nameDataArray[0]][id][unixDate] = {};
          }
          if (angular.isUndefined(AbsoluteData[nameDataArray[0]][id])) {
            AbsoluteData[nameDataArray[0]][id] = {};
          }
          if(angular.isUndefined(AbsoluteData[nameDataArray[0]][id][unixDate])){
            AbsoluteData[nameDataArray[0]][id][unixDate] = {};
          }

          //asigna datos
          //si es padre o es hijo, asigna respectivamente
          //  Ej:
          //  padre: vinedod
          //  hijo: vinedo.algo
          if (angular.isDefined(nameDataArray[1])) {
            AbsoluteData[nameDataArray[0]][id][unixDate][nameDataArray[1]] = angular.copy(data);
          }else{
            AbsoluteData[nameDataArray[0]][id][unixDate] = angular.copy(data);
          }

      };






      var remove = function remove(nameData, id, unixDate) {
        consoleLog("remove: "+nameData + " "+ id + " " + unixDate);
        borrarTodo = false;
        if(unixDate === 0){
          borrarTodo = true;
        }else{
          unixDate = unixDate || actualUnix;
          unixDate = roundUnix(unixDate);
        }

        nameDataArray = splitName(nameData);
        if (existData(nameData, id, unixDate) || borrarTodo) {
          if (angular.isDefined(nameDataArray[1])) {
            if(borrarTodo){
              if(angular.isDefined(AbsoluteData[nameDataArray[0]]) && angular.isDefined(AbsoluteData[nameDataArray[0]][id]))
              angular.forEach(AbsoluteData[nameDataArray[0]][id],function(item){
                item[nameDataArray[1]] = undefined;
              });
            }else{
              AbsoluteData[nameDataArray[0]][id][unixDate][nameDataArray[1]] = undefined;
            }
          }else{
            AbsoluteData[nameDataArray[0]][id][unixDate] = undefined;
          }
          return true;
        }
        return false;
      };






      var action = function (nameData, id, data, unixDate) {
        consoleLog("action: "+nameData + " "+ id + " " + unixDate);
        borrarTodo = false;
        if(unixDate === 0){
          borrarTodo = true;
        }else{
          unixDate = unixDate || actualUnix;
          unixDate = roundUnix(unixDate);
        }

        nameDataArray = splitName(nameData);
        removeData = Actions[nameData];

        if(angular.isDefined(removeData)){
          angular.forEach(removeData.clean, function (name, in1) {
            nameArray = splitName(name);
            if (angular.isDefined(data[nameArray[0]+'Ids'])){
              angular.forEach(data[nameArray[0]+'Ids'], function (itemId, in2) {
                consoleLog('remove: '+name+' '+itemId+' unix: '+unixDate);
                remove(name, itemId, unixDate);
              });
            }
          });
        }
      };



      return {
        get    : get,
        set    : set,
        remove : remove,
        action : action
      };
  });

}());
